module.exports = __webpack_public_path__ + "img/national-qualification-level-1.18db3bce.jpg";